// /frontend/src/services/socket.js
import { io } from 'socket.io-client';

const SOCKET_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:3000';

// console.log('SOCKET_URL:', SOCKET_URL);

class SocketService {
    constructor() {
        this.socket = null;
        this.isConnecting = false;
    }

    connect() {
        if (this.socket?.connected || this.isConnecting) {
            return;
        }

        this.isConnecting = true;
        this.socket = io(SOCKET_URL, {
            auth: {
                token: localStorage.getItem('token')
            },
            autoConnect: false,
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000
        });

        this.socket.on('connect', () => {
            console.log('Connected to Socket.IO server');
            this.isConnecting = false;
        });

        this.socket.on('connect_error', (error) => {
            console.error('Socket connection error:', error);
            this.isConnecting = false;
        });

        this.socket.connect();
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
            this.isConnecting = false;
        }
    }

    joinContractRoom(contractId) {
        if (this.socket?.connected && contractId) {
            this.socket.emit('joinContract', contractId);
        }
    }

    leaveContractRoom(contractId) {
        if (this.socket?.connected && contractId) {
            this.socket.emit('leaveContract', contractId);
        }
    }

    onActionCreated(callback) {
        if (this.socket?.connected) {
            this.socket.on('actionsCreated', callback);
        }
    }

    onActionUpdated(callback) {
        if (this.socket?.connected) {
            this.socket.on('actionUpdated', callback);
        }
    }

    onActionDeleted(callback) {
        if (this.socket?.connected) {
            this.socket.on('actionDeleted', callback);
        }
    }

    removeAllListeners() {
        if (this.socket?.connected) {
            this.socket.removeAllListeners();
        }
    }
}

// Create a singleton instance
const socketService = new SocketService();

export default socketService;